<script>
import api from '@/api/wp/cart'

import { ADD_TO_CART_EVENT, CartBus }  from '@/components/addToCart/AddToCart.vue'

export default {

    data() {
        return {
            processing: false,
        }
    },

    methods: {
        
        addToCart(articles) {
            
            this.processing = true

            api.postMultipleArticles(articles)
                .then( () => {
                    this.$notify.success("Articles ajouté au panier") 
                    this.refreshCart();
                })
                .catch( () => this.$notify.error("Impossible d'ajouter les articles au panier") )
                .finally( () => this.processing = false )
        },

        refreshCart: function() {
            console.log("🛒 Article(s) ajouté(s) au panier")
            const event = document.createEvent( 'Event' );
            event.initEvent( 'wc_fragment_refresh', true, true );
            document.body.dispatchEvent( event );
        }
    },

    created() {
        CartBus.$on(ADD_TO_CART_EVENT, () => {
            this.refreshCart();
        })
    }
}

</script>
 